export const colors = {
    black: '#353e49',
    accent: '#83766A',
    grey: '#616373',
    lightGrey: '#cfcfcf',
    gold: '#c9b998',
    textColor: '#666',
    offWhite: '#f4f4f4',
};
